/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-04-24 12:54:32
 */
import axios from "axios";
import { CmsUrl, Url } from "src/config";
import { bearerToken } from "src/config";


const surveyAPIService = {
  /**
   * Function to check invite id
   * @param {object} inviteIdData
   * @param {string} accessToken
   * @returns
   */
  checkInviteId: async (inviteIdData, accessToken) => {
    try {
      const response = await axios.post(
        `${Url}/customer/checkInviteId`,
        inviteIdData,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  /**
   * API call to check survey section
   * @returns
   */
  getSurveySections: async (surveyData, accessToken,tenantId) => {
    console.log("----survey data----", surveyData,tenantId);
    try {
      let condition = '';
      if(tenantId!== undefined && tenantId !== null){
        condition = `?tenant_id=${tenantId}`
      }
      const response = await axios.post(
        `${Url}/customer/getSurveySections${condition}`,
        surveyData,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error.response.data;
    }
  },
  /**
   * API call to get questions of a section
   * @param {object} surveyQuestionData
   * @returns
   */
  getSurveyQuestions: async (surveyQuestionData, accessToken,tenantId) => {
    console.log("survey question data", surveyQuestionData);
    try {
      let condition = '';
      if( (tenantId!==null && tenantId !== undefined)){
        condition = `?tenant_id=${tenantId}`
      }
      const response = await axios.post(
        `${Url}/customer/getSurveyQuestions${condition}`,
        surveyQuestionData,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      return error;
    }
  },
  /**
   * API call to submit survey
   * @param {*} surveyResponse
   * @returns
   */
  submitSurveyResponse: async (surveyResponse, accessToken,tenantId) => {
    try {
      let condition = '';
      if( tenantId !== null && tenantId !== undefined){
        condition = `?tenant_id=${tenantId}`
      }
      console.log("survey respone in api", surveyResponse);
      const response = await axios.post(
        `${Url}/customer/submitSurveyAnswers${condition}`,
        surveyResponse,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  /**
   * Function to check current status of wiredup survey
   * @param {*} accessToken
   * @returns
   */
  checkSurveyStatus: async (accessToken) => {
    try {
      const response = await axios.get(`${Url}/customer/getwiredupstatus`, {
        headers: {
          "access-token": accessToken,
        },
      });
      console.log("response", response);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  getColorCode : async (accessToken) => {
    try {
      const response = await axios.get(`${Url}/customer/getcolorcode`, {
        headers: {
          "access-token": accessToken,
        },
      })
      return response.data
    } catch (error) {
      
    }
  },
  getSurveyIntropageData: async (id) =>{
    // const bearerToken = 'd6d619c3f797679078b73e36d74119e61871ac381df0b404c91c735981310acc5f8604657058f498ed0479f57e6668d2678941b58ea7e2974739813ce44e76b868b6a515cd60fb5be79708de41a36100ac15dea63d5cf614d9dda5371727c639c9ef31b4fed536a489a7f58f5e601b47d676f0b4299089c14ec8bbc57f80e291';

    try {
      const response = await axios.get(`${CmsUrl}/surveys-intros?filters%5Bsurvey_id%5D=${id}
      `,{headers: {
        'Authorization': `Bearer ${bearerToken}`,
        'Content-Type': 'application/json', // You can add other headers as needed
      },});
      return response.data
    } catch (error) {
      
    }
  },
  getCustomerUsers : async (accessToken,searchdata) => {
   
 
    try {
      let condition = '';
      if(searchdata && searchdata.length>2){
        condition = `?search=${searchdata}`
      }
      const response = await axios.get(`${Url}/customer/getUsers${condition}`,{
        headers: {
          "access-token": accessToken,
        },
      });
     return  response.data
    } catch (error) {
      return error
    }
  },
  sendSurveyInvitation : async (accessToken,users,data) =>{
    try {
      console.log('--team id in service--',data);
     
      console.log('accessToken,users,surveyId,senderId',accessToken,users,data.surveyId,data.senderId,data.teamId);
      const response = await axios.post(`${Url}/customer/inviteUsers?userId=${data.senderId}&surveyId=${data.surveyId}&senderName=${data.senderName}&teamId=${data.teamid}`,users,{headers: {
        'access-token':accessToken
      },})
      console.log('invite responseee',response);
     return  response.data
    
    } catch (error) {
      return error
    }
  },
  postSurveyFeedback: async (data, accessToken) => {
    console.log("survey feedback data", data);
    try {
      const response = await axios.post(
        `${Url}/customer/submitfeedback`,
        data,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

export default surveyAPIService;
